<template>
    <div class="news">
        <div class="fixed-container">
            <van-tabs v-model="active" type="card" color="#0081ff" class="custom-tabs">
                <van-tab title="新闻动态"></van-tab>
                <van-tab title="在线学习"></van-tab>
                <van-tab title="文件政策"></van-tab>
            </van-tabs>
            <van-search v-model="searchValue" placeholder="输入搜索内容" clearable show-action shape="round"
                @search="onSearch">
                <template #action>
                    <div @click="onSearch">搜索</div>
                </template>
            </van-search>
            <van-grid :column-num="4" :border="false">
                <van-grid-item v-for="(area, index) in areaList" :key="index" :text="area.name"
                    :class="{ 'selected-area': index === selectedIndex }" @click="selectArea(area.areaCode, index)" />
            </van-grid>
        </div>
        <div class="list-container">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                <van-cell-group>
                    <van-cell v-for="(item, index) in list" :key="index" :title="item.title"
                        :label="item.releaseTime !== null ? item.releaseTime.slice(0, 10) : '-'" is-link
                        @click="$router.push({ name: 'NewsDetail', params: { detail: JSON.stringify(item) } })">
                        <!-- <template #icon>
              <img v-if="appOrPC" :src="item.images && item.images.length > 0 ? getIMGURL(item.images[0]) : ''" alt=""
                style="width: 48px; height: 48px; margin-right: 8px">
              <img v-else
                :src="item.images && item.images.length > 0 ? IMAGE_URL + `?id=${item.images[0]}&token=${token}` : ''"
                alt="" style="width: 48px; height: 48px; margin-right: 8px">
            </template> -->
                    </van-cell>
                </van-cell-group>
            </van-list>
        </div>
    </div>
</template>

<script>
import { get } from '@/utils/api'
import { appOrPC, ipType, IMAGE_URL, interface_pubkey1, interface_prikey1 } from '@/utils/config';
export default {
    name: 'NewsPage',
    data() {
        return {
            active: 0,
            list: [],
            loading: false,
            finished: false,
            areaPopupShow: false,
            areaListArray: [],
            areaList: [
                { name: "不限", areaCode: "" }
            ],
            areaSelectIndex: 0,
            type: 0,
            pageNo: 1,
            pageSize: 20,
            areaCode: "",
            streetName: "选择镇街",
            searchType: "新闻动态",
            IMAGE_URL: IMAGE_URL,
            appOrPC: appOrPC,
            searchValue: "",
            selectedIndex: 0,
        }
    },
    mounted() {
        setTimeout(() => {
            this.getAreaData();
            // this.onLoad()
        }, 1000);

    },
    methods: {
        async onLoad() {
            this.type = this.active;
            if (appOrPC) {
                let that = this, extraData = {
                    header: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                        "App-Version-Code": "v2.0.0"
                    }
                }, newsArray = [];
                vaildInterfacefn(
                    "hhwzzcsesonq",
                    "rcshhwtyjkV0",
                    JSON.stringify({
                        ipType: ipType,
                        methodType: "get",
                        methodName: "api/app/news/page",
                        type: that.active,
                        pageNo: that.pageNo,
                        pageSize: 20,
                        searchValue: that.searchValue,
                        areaCode: that.areaCode,
                    }),
                    "1",
                    extraData
                ).then((value) => {
                    if (value == false) {
                        return;
                    } else {
                        const de_value = JSON.parse(value)
                        if (de_value.code == 200 && de_value.success) {
                            newsArray = de_value.data.rows;
                            // for (let i = 0; i < newsArray.length; i++) {
                            //     that.list.push({
                            //         id: newsArray[i].id,
                            //         title: newsArray[i].title,
                            //         label: newsArray[i].abstarct,
                            //         date: newsArray[i].releaseTime !== null ? newsArray[i].releaseTime.slice(0, 10) : "-",
                            //         imageUrl: newsArray[i].imageId !== undefined ? newsArray[i].imageId : newsArray[i].imageUrl,
                            //     });
                            // }
                            that.list = that.list.concat(newsArray)
                            that.pageNo++;
                            that.loading = false;
                            console.log("length:", newsArray.length)
                            if (newsArray.length < 20) {
                                that.finished = true;
                            }
                        } else {
                            that.$toast.fail(de_value.message || '获取新闻列表失败');
                            that.finished = true;
                        }
                    }
                })
            } else {
                const param = {
                    type: this.active,
                    pageNo: this.pageNo,
                    pageSize: 20,
                    searchValue: this.searchValue,
                    areaCode: this.areaCode,
                };
                const res = await get('/news/page', param);
                let newsArray = [];
                if (res.code == 200 && res.success) {
                    newsArray = res.data.rows;
                    this.list = this.list.concat(newsArray)
                    this.pageNo++;
                    this.loading = false;
                    console.log("length:", newsArray.length)
                    if (newsArray.length < 20) {
                        this.finished = true;
                    }
                } else {
                    this.$toast.fail(res.message || '获取新闻列表失败');
                    this.finished = true;
                }

            }


        },
        // 获取地区列表
        async getAreaData() {
            console.log("执行获取地区列表areaList方法")
            if (appOrPC) {
                let that = this, extraData = {
                    header: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                        "App-Version-Code": "v2.0.0"
                    }
                }
                vaildInterfacefn(
                    "hhwzzcsesonq",
                    "rcshhwtyjkV0",
                    JSON.stringify({
                        ipType: ipType,
                        methodType: "get",
                        methodName: "api/common/areaCodes",
                        levelCode: "3"
                    }),
                    "1",
                    extraData
                ).then((value) => {
                    if (value == false) {
                        return;
                    } else {
                        try {
                            const de_value = JSON.parse(value)
                            if (de_value.code == 200 && de_value.success) {
                                that.areaList = that.areaList.concat(de_value.data);
                                console.log("获取地区列表areaList：", that.areaList)
                            } else {
                                that.$toast.fail(de_value.message || '获取地区列表失败');
                            }
                        } catch (error) {
                            that.getAreaData()
                        }
                    }
                })
            } else {
                const param = {
                    levelCode: "3"
                };
                const res = await get('http://101.35.126.37:8081/api/common/areaCodes', param);
                if (res.code == 200 && res.success) {
                    this.areaList = this.areaList.concat(res.data);
                    console.log("获取地区列表areaList：", this.areaList)
                } else {
                    this.$toast.fail(res.message || '获取地区列表失败');
                }
            }
        },
        getImage(id) {
            let token = localStorage.getItem("token")
            return IMAGE_URL + `?id=${id}&token=${token}`
        },
        getIMGURL(id, type) {
            const token = localStorage.getItem("token");
            let url = "", that = this
            if (type) {
                if (id == "") {
                    return require('@/assets/icon/noimage.png');
                } else {
                    url = id
                }
            } else {
                url = that.IMAGE_URL + `?id=${id}&token=${token}`
            }
            try {
                const param = {
                    ipType: ipType,
                    methodType: "get",
                    methodName: "getImageBase64",
                    imgURL: url
                };
                vaildInterfacefn(
                    "hhwzzcsesonq",
                    "rcshhwtyjkV0",
                    JSON.stringify(param),
                    "1"
                ).then((value) => {
                    if (value == false) {
                        throw new Error('获取图片失败');
                        // return
                    } else {
                        const de_value = JSON.parse(value);
                        if (de_value.code === 200 && de_value.imageBase64) {
                            const base64Image = "data:image/jpeg;base64," + de_value.imageBase64;
                            // console.log("base64Image:", base64Image);
                            return base64Image;
                        } else {
                            throw new Error(de_value.msg || '获取图片失败');
                        }
                    }
                })
            } catch (error) {
                console.error('获取图片失败:', error);
                this.$toast.fail('获取图片失败');
                // 返回默认图片
                return require('@/assets/icon/noimage.png');
            }
        },
        showDetail(item) {
            this.$router.push({ name: `NewsDetail`, params: { detail: JSON.stringify(item) } });
        },
        // onSearch() {
        //     localStorage.setItem('newsSearchQuery', '');
        //     localStorage.setItem('searchType', this.active);
        //     localStorage.setItem('areaCode', this.areaCode);
        //     this.$router.push({ path: '/search-news' });
        // },
        // selectArea(i, value, name) {
        //     this.areaSelectIndex = i;
        //     this.areaPopupShow = false;
        //     this.areaCode = value
        //     this.streetName = name === "不限" ? "选择镇街" : name
        //     this.finished = false
        //     this.loading = true
        //     this.list = []
        //     this.pageNo = 1
        //     this.onLoad()
        // }
        // 搜索栏搜索
        onSearch() {
            this.list = [];
            this.pageNo = 1;
            this.areaCode = "";
            this.finished = false;
            this.loading = true
            this.onLoad();
        },
        // 镇街点击搜索
        selectArea(areaCode, index) {
            this.areaCode = areaCode;
            this.selectedIndex = index;
            this.list = [];
            this.pageNo = 1;
            this.finished = false;
            this.loading = true
            this.onLoad();
        },
    },
    watch: {
        active(val) {
            switch (val) {
                case 0:
                    this.searchType = "新闻动态"
                    break;
                case 1:
                    this.searchType = "在线学习"
                    break;
                case 2:
                    this.searchType = "文件政策"
                    break;
                default:
                    this.searchType = ""
                    break;
            }

            // Reset state for new tab
            this.finished = false;
            this.list = [];
            this.pageNo = 1;

            // Only load if not already loading
            if (!this.loading) {
                this.loading = true;
                this.onLoad();
            }
        }
    }
}
</script>

<style scoped>
.news {
    padding: 10px;
    background-color: #f5f7fa;
    min-height: 100vh;
}

.news-container {
    background-color: #f5f7fa;
    min-height: 100vh;
    padding-bottom: 50px;
    /* 调整顶部内边距，确保足够空间 */
    position: relative;
    /* 添加相对定位 */
    overflow-x: hidden;
    /* 防止水平滚动 */
}

html,
body {
    overflow: hidden;
    height: 100%;
}

.news-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 90px;
    overflow: hidden;
    padding-right: 24px;
    /* 添加右侧内边距，为箭头图标留出空间 */
}

.fixed-container {
    position: relative;
    background: white;
}

.selected-area /deep/ .van-grid-item__text {
    color: #1989fa;
}

.list-container {
    height: calc(100vh - 120px);
    overflow-y: auto;
    margin-top: 10px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    padding: 12px;
}

.van-grid-item /deep/ .van-grid-item__content {
    padding: 4px 8px;
}


.list-container .van-cell {
  padding: 12px 16px;
  margin-bottom: 8px;
  border-radius: 8px;
  background: white;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.van-cell /deep/ .van-cell__title {
    font-size: 16px;
    color: #333;
    font-weight: 500;
}

.van-cell /deep/ .van-cell__label {
    font-size: 14px;
    color: #666;
    margin-top: 4px;
}

.van-search {
    /* margin: 12px 0; */
    border-radius: 8px;
    overflow: hidden;
}

.van-search /deep/ .van-search__content {
    background-color: #f5f5f5;
}

.van-search /deep/ .van-field__control {
    font-size: 14px;
}

.van-search /deep/ .van-search__action {
    color: #0081ff;
    font-weight: 500;
    padding: 0 12px;
}
</style>
